<cx-window
    i18n-title="@@benchmark-dashboard.editor.favourites.window.titel"
    title="Favourites"
    [height]="400"
    [width]="250"
    class="dashboard.editor.favourites.window"
    name="benchmark-dashboard.editor.favourites.window"
    test-id="benchmark-dashboard.editor.favourites.window"
>
    <div class="toolbar">
        <button
            class="default icon fa fa-refresh toolbar-button choose-datapoint-button"
            title="refresh"
            test-id="benchmark-dashboard.editor.favourites.window.buttons.refresh"
            i18n-title="@@benchmark-dashboard.editor.favourites.window.refresh.button"
            (click)="list.refresh()"
        ></button>
        <button
            class="default icon fa fa-object-ungroup toolbar-button choose-datapoint-button"
            title="Select all"
            test-id="benchmark-dashboard.editor.favourites.window.buttons.select-all"
            i18n-title="@@benchmark-dashboard.editor.favourites.window.select-all.button"
            (click)="list.selectAll()"
        ></button>
        <button
            class="default icon fa fa-trash toolbar-button choose-datapoint-button"
            title="delete selected"
            test-id="benchmark-dashboard.editor.favourites.window.buttons.delete-selected"
            i18n-title="@@benchmark-dashboard.editor.favourites.window.delete-selected.button"
            (click)="list.deleteSelected()"
        ></button>
    </div>

    <favourites-view-list #list [filter]="filter"></favourites-view-list>
</cx-window>